export default __webpack_public_path__ + "static/media/foot-data.8f1655de.png";